import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { ClearTobaccoProductionsReducer, GetConveyorTobaccoProductionReducer } from './reducers';
import { GetConveyorTobaccoProduction } from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'tobaccoHumidificationProduction',
  initialState,
  reducers: {
    ClearTobaccoProductions: ClearTobaccoProductionsReducer,
  },
  extraReducers: (builder) => {
    // GetConveyorTobaccoProduction
    addExtraReducer(builder, GetConveyorTobaccoProduction, GetConveyorTobaccoProductionReducer);
  },
});

export default slice.reducer;
